import { Card, CardContent } from '@material-ui/core'
import { ArrowDropDown, Image } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import defaultProjectThumb from '../../assets/img/default-project.png'
import { ReactComponent as ChatIcon } from '../../assets/img/icons/comments.svg'
import { useDateFormatter } from '../../hooks/useDateFormatter'
import ActionsMenu from '../ActionsMenu/ActionsMenu'
import ProjectProgressBar from './ProjectProgressBar'

interface Props {
  project: Project
  handleDeleteClick: (project: Project) => void
  handleEditViewClick: (project: Project) => void
  handleArchiveClick?: (project: Project) => void
}

const ProjectCard = ({
  project,
  handleDeleteClick,
  handleEditViewClick,
  handleArchiveClick = () => {},
}: Props) => {
  const { userInfo } = useSelector(
    (state: { userLogin: UserLogin }) => state.userLogin
  )

  const canDeleteAndArchiveOptions = [
    {
      onClick: () => handleEditViewClick(project),
      label: 'Edit/View',
    },
    {
      onClick: () => handleArchiveClick(project),
      label: 'Archive',
    },
    {
      onClick: () => handleDeleteClick(project),
      label: 'Delete',
    },
  ]

  const canDeleteOptions = [
    {
      onClick: () => handleEditViewClick(project),
      label: 'Edit/View',
    },
    {
      onClick: () => handleDeleteClick(project),
      label: 'Delete',
    },
  ]

  const canArchiveOptions = [
    {
      onClick: () => {
        handleEditViewClick(project)
      },
      label: 'Edit/View',
    },
    {
      onClick: () => handleArchiveClick(project),
      label: 'Archive',
    },
  ]

  const cannotDeleteOptions = [
    {
      onClick: () => handleEditViewClick(project),
      label: 'Edit/View',
    },
  ]

  const handleDoubleClick = () => {
    handleEditViewClick(project)
  }

  return (
    <div className={`card-wrapper project`}>
      <Card className={`white-card`} onDoubleClick={handleDoubleClick}>
        <div
          className={`thumbnail-container no-thumbnail`}
          style={{
            backgroundImage: `url(${defaultProjectThumb})`,
          }}
        ></div>

        <CardContent>
          <div className="content">
            <div className="flex space-between">
              <div style={{ width: '100%' }}>
                <div
                  className="flex align-center space-between"
                  style={{ marginTop: -6, width: '100%' }}
                >
                  <div
                    className="flex align-center"
                    style={{ maxWidth: 'calc(100% - 32px)' }}
                  >
                    <h4 className="m-b-0 truncate">{project.name}</h4>
                    {userInfo.isAdmin ? (
                      <ActionsMenu
                        icon={<ArrowDropDown />}
                        options={
                          userInfo.role === 'Manager' ||
                          userInfo.role === 'Support'
                            ? project.status === 'Archived'
                              ? canDeleteOptions
                              : canDeleteAndArchiveOptions
                            : canArchiveOptions
                        }
                      />
                    ) : (
                      <ActionsMenu
                        icon={<ArrowDropDown />}
                        options={
                          project.status === 'New'
                            ? canDeleteOptions
                            : cannotDeleteOptions
                        }
                      />
                    )}
                  </div>

                  {project.hasUnreadActivity && <ChatIcon />}
                </div>
                <p className="gray-text"> Contract {project.type}</p>
              </div>
            </div>

            <div className="flex align-center last-updated m-b-8">
              {project.assigneeInitials && (
                <p
                  className="name-dot m-r-8"
                  style={{ minWidth: 20, minHeight: 20, paddingBottom: 6 }}
                >
                  <span>{project.assigneeInitials}</span>
                </p>
              )}

              <p style={{ minHeight: 23, lineHeight: '23px' }}>
                {project.assigneeName && project.assigneeName}
              </p>
            </div>

            <div className="flex">
              <p>
                <strong className="m-r-10">Last updated:</strong>
              </p>
              <p>{useDateFormatter(project.updatedAt)}</p>
            </div>

            <div className="flex space-between m-t-8 align-center">
              <Image style={{ width: 16 }} className="m-r-8" />
              <ProjectProgressBar
                project={project}
                style={{ maxWidth: 'unset', width: '100%' }}
                className={`m-r-24 hide-991 relative ${
                  project.status === 'Archived' ? 'gray' : ''
                }`}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default ProjectCard
